import { render, staticRenderFns } from "./AvatarUpload.vue?vue&type=template&id=79fd1def&scoped=true"
import script from "./AvatarUpload.vue?vue&type=script&lang=js"
export * from "./AvatarUpload.vue?vue&type=script&lang=js"
import style0 from "./AvatarUpload.vue?vue&type=style&index=0&id=79fd1def&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fd1def",
  null
  
)

export default component.exports